module.exports = __webpack_public_path__ + "static/media/7.c6a2ccd7.jpg";